import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "@stores/auth/authStore";

/**
 * Drops every cached server response when a signed-in account signs out or is replaced, so the
 * next account on the same browser never sees the previous one's cached data.
 */
export const SessionCacheReset: React.FC = () => {
    const queryClient = useQueryClient();
    const userId = useAuthStore((s) => s.user?.id ?? null);
    const previous = React.useRef(userId);

    React.useEffect(() => {
        if (previous.current !== null && previous.current !== userId) queryClient.clear();
        previous.current = userId;
    }, [userId, queryClient]);

    return null;
};
